// Forks: font stylesheet URLs per design, replacing that design's own list; shipped empty and never changed by us.
export const customFonts: Record<string, string[]> = {};
